export const TRACKING_PIXEL = {
  TYPES: {
    IMG: 'img',
    IFRAME: 'iframe',
    SCRIPT: 'script',
  },
} as const;

export const GA4_EVENTS = {
  RB_DOWNLOAD_RESUME: 'rb_download_resume',
  SAVE_JOB: 'save_job',
  DISMISS_JOB: 'dismiss_job',
  DELETE_RESUME: 'delete_resume',
  COMPANY_CLAIM: 'company_claim',
  DLP_APPLY_CLICK: 'dlp_apply_click',
  CAROUSEL_JOB_CLICK: 'carousel_job_click',
  JOB_CLICK: 'job_click',
  BEGIN_CHECKOUT: 'begin_checkout',
  LOGIN: 'login',
  LOGIN_FAILED: 'login_failed',
  SIGN_UP: 'sign_up',
  SIGN_UP_FAILED: 'sign_up_failed',
  JOB_FILTER_CLICK: 'job_filter_click',
  SALARY_FILTER_CLICK: 'salary_filter_click',
  CONTENT_FILTER_CLICK: 'content_filter_click',
  SEARCH: 'search',
  DLP_APPLY_RESUME_SUBMITTED: 'dlp_apply_resume_submitted',
  RB_CALLOUT_CLICK: 'rb_callout_click',
  JOB_CALLOUT_CLICK: 'job_callout_click',
  CAREER_QUIZ_CALLOUT_CLICK: 'career_quiz_callout_click',
  REVIEWS_CALLOUT_CLICK: 'reviews_callout_click',
  SALARY_REPORT_CALLOUT_CLICK: 'salary_report_callout_click',
} as const;

export const STRIPE_RESUME_BUILDER_PLANS = {
  STANDARD: {
    KEY: 'STANDARD_PLAN_ID',
    TITLE: 'Standard',
    PRICE: '25',
  },
} as const;

export const STRIPE_POST_A_JOB_PLANS = {
  STANDARD: {
    KEY: 'STANDARD_PLAN_ID',
    TITLE: 'Standard',
    PRICE: '499',
  },
  PREMIUM: {
    KEY: 'PREMIUM_PLAN_ID',
    TITLE: 'Premium',
    PRICE: '749',
  },
  ENTERPRISE: {
    KEY: 'ENTERPRISE_PLAN_ID',
    TITLE: 'Enterprise',
    PRICE: '1199',
  },
} as const;

export const PLAN_CATEGORIES = {
  RESUME_BUILDER: 'RESUME_BUILDER',
  EMPLOYER_JOB_POSTING: 'EMPLOYER_JOB_POSTING',
} as const;

export const SEARCH_SOURCES = {
  CLUSTER_HEADER: 'cluster-header',
  MAIN_HEADER: 'main-header',
  COMPANY_SEARCH: 'company-search',
  SITE_MAP_SEARCH_ALL: 'site-map-search-all',
  SITE_MAP_SEARCH: 'site-map-search',
  JOB_SEARCH: 'job-search',
}

export const SURVEYS = {
  SALARY_REPORT: '201',
};

export const GA4_EMPLOYER_EVENTS = {
  DOWNLOAD: 'download',
  INTERESTED: 'interested',
  NOT_INTERESTED: 'not-interested',
  EMAIL_COPY: 'email-copy',
  CANDIDATES_CLICK: 'candidates-click',
  JOB_DESCRIPTION_TEMPLATE_CLICK: 'job-description-template-click',
};
